import type { HTMLAttributes, ReactNode } from 'react';
import { type Tone, TONE_BORDER } from '../lib/theme.ts';
import { Icon } from './Icon.tsx';

/** The heading every screen opens with: a gilt icon, then the name. */
export function PageTitle({ icon, children }: { icon?: string; children: ReactNode }) {
  return (
    <h1 className="text-3xl">
      {icon && <Icon name={icon} className="mr-2 text-gilt" />}
      {children}
    </h1>
  );
}

/** A message ruled off on the left in its tone: what just happened, how a crime went, an error. */
export function Callout({ tone, className = '', children, ...props }: { tone: Tone } & HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={`border-l-2 pl-3 text-sm ${TONE_BORDER[tone]} ${className}`} {...props}>
      {children}
    </p>
  );
}
